import { useMemo } from 'react';
import { Typography } from 'seagull';
import LegalTermsDropdown from "../../../../components/LegalTermsDropdown/LegalTermsDropdown";
import { useStore, useStoreActions } from "../../../../contexts";
import { legalTermsModel } from "../../../../models";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getLegalTerms } from "../EditDraftsTable.utils";
import { selectors } from "../../../../store/state-selectors";
import { jsx as _jsx } from "react/jsx-runtime";
const getLegalTermsId = draft => {
  const legalTerms = draft.legalTerms();
  return legalTerms != null && 'libraryLegalTermsId' in legalTerms ? legalTerms.libraryLegalTermsId : null;
};
function TermsOfServiceModalContent(_ref) {
  let {
    draft,
    setDraft
  } = _ref;
  const {
    fetchLegalTerms
  } = useStoreActions();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const worksAt = useStore(selectors.user.business);
  const availableLegalDocs = useMemo(() => {
    const legalTerms = draft.legalTerms();
    if (legalTermsDocuments == null) return [];
    if (legalTermsDocuments.some(_ref2 => {
      let {
        id
      } = _ref2;
      return id === getLegalTermsId(draft);
    })) return legalTermsDocuments;
    if ((legalTerms === null || legalTerms === void 0 ? void 0 : legalTerms.type) === 'libraryLegalTermsId') {
      return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTerms(legalTerms)]);
    }
    if (legalTermsDocuments.some(_ref3 => {
      let {
        id
      } = _ref3;
      return id === getLegalTermsId(draft);
    })) {
      return legalTermsDocuments;
    }
    return legalTermsDocuments.concat([legalTermsModel.fromDraftLegalTerms(legalTerms)]);
  }, [legalTermsDocuments, draft]);
  const fileId = useMemo(() => {
    const {
      legalTermsDocumentId
    } = (worksAt === null || worksAt === void 0 ? void 0 : worksAt.settings) || {};
    const legalTermsId = getLegalTermsId(draft);
    return legalTermsId || legalTermsDocumentId || null;
  }, [worksAt, draft]);
  return /*#__PURE__*/_jsx(LegalTermsDropdown, {
    legalTerms: availableLegalDocs,
    selectedLegalTerms: availableLegalDocs.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === fileId;
    }),
    onUpload: fetchLegalTerms,
    onChange: id => {
      setDraft(draft.setLegalTerms({
        type: 'libraryLegalTermsId',
        libraryLegalTermsId: id
      }));
    }
  });
}
export default function TermsOfServiceCell(_ref5) {
  var _legalTerms$name;
  let {
    isDisabled,
    disabledTooltip,
    draft,
    index,
    onOpenModal
  } = _ref5;
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const legalTerms = useMemo(() => getLegalTerms(draft, legalTermsDocuments), [draft, legalTermsDocuments]);
  const onClick = () => onOpenModal({
    renderContent: _ref6 => {
      let {
        draft,
        setDraft
      } = _ref6;
      return {
        title: 'Terms of service',
        testid: 'edit-terms-modal',
        content: /*#__PURE__*/_jsx(TermsOfServiceModalContent, {
          draft: draft,
          setDraft: setDraft
        }),
        onSubmit: defaultBehavior => {
          defaultBehavior();
        }
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-terms-of-service-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "terms-of-service-".concat(index),
      children: (_legalTerms$name = legalTerms === null || legalTerms === void 0 ? void 0 : legalTerms.name) !== null && _legalTerms$name !== void 0 ? _legalTerms$name : ''
    })
  });
}